/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_d3b64d14{color:var(--color-body-contentColor);font-family:var(--body-fontFamily);font-weight:var(--body-fontWeight);font-size:var(--body-fontSize)}"}]);
export const root = "root_d3b64d14";